import { AfterContentInit, Component, ContentChildren, OnInit, QueryList } from '@angular/core';
import { AutoDisableButtonDirective } from './auto-disable-button.directive';

@Component({
    selector: 'app-auto-disable-menu-button',
    templateUrl: './auto-disable-menu-button.component.html',
    styleUrls: ['./auto-disable-menu-button.component.scss'],
    standalone: false
})
export class AutoDisableMenuButtonComponent implements AfterContentInit {

  @ContentChildren(AutoDisableButtonDirective) childButtons!: QueryList<AutoDisableButtonDirective>

  disabled = false

  constructor() { }

  ngAfterContentInit(): void {
    if (this.childButtons.some(b => !b.hide)) this.disabled = false
    else this.disabled = true
  }

}
